import abTests from 'frontend/shared/javascripts/modules/ab_tests'
import type { UserHomeSidebarGroup } from 'frontend/unpoly/javascripts/user_home_sidebar/types'

// Only the variation of the A/B test user_home_hub shows the sidebar, so only its visitors load it.
up.compiler(
  '[data-user-home-sidebar]',
  (element, { groups }: { groups: UserHomeSidebarGroup[] }) => {
    let variation = false
    let unmount: (() => void) | undefined

    async function mount() {
      const { mountUserHomeSidebar } =
        await import('frontend/unpoly/javascripts/user_home_sidebar/component')

      if (variation && !unmount && element.isConnected) {
        unmount = mountUserHomeSidebar(element, groups)
      }
    }

    const stopListening = abTests.onVariant('user_home_hub', (variant) => {
      variation = variant === 'b'
      if (variation) {
        void mount()
      } else {
        unmount?.()
        unmount = undefined
      }
    })

    return () => {
      stopListening()
      unmount?.()
    }
  },
)
